import React, { useState, useEffect } from 'react';
import VainillaDialogV2 from '../../../../../utils/VainillaDialogv2';
import vr from '../../../../../utils/Verifiers';

const EditorSemanasInventarioCampoExterno = (p) => {
    const close = p?.close ?? (() => { });
    const [data, setdata] = useState({ ...(p?.data ?? {}) });
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white3 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });

    useEffect(() => {
    }, [data]);

    const changeData = (e) => setdata({ ...data, [e.target.name]: e.target.value });

    const actualizar = async () => {
        const resp = await vr.getDataAPI('campo/v2/inventario_campo/externo/ajustar', {
            id: data.id,
            semana_siembra: data.semana_siembra,
            semana_trasplante: data.semana_trasplante,
            flor: data.flor,
            variedad: data.variedad,
            color: data.color,
            dias_vivero: data.dias_vivero
        }, setloader, setdialog);
        if (resp.estatus) {
            close(true);
            return;
        }

    }

    return (
        <>
            <button className='btn btn-danger bg-red4 bw-200 text-bold shadow btn-lg round-xl'
                style={{ position: "fixed", top: "15px", right: "30px", zIndex: 1001 }}
                onClick={() => close(false)}>Cerrar editor</button>
            <div className='vw-100 vh-100 m-0 p-2'
                style={{ position: 'fixed', top: '0', left: '0', zIndex: 1000, backdropFilter: 'blur(5px)', backgroundColor: 'rgba(255, 255, 255, 0.24)', overflow: 'auto', }}
            >
                <div className='w-100' style={{ marginTop: "65px" }}></div>
                <div className={`row w-100 m-0 p-0 justify-content-center`}>
                    <div className="bw bg-white shadow-lg" style={{ '--bw': '1000px' }}>
                        <div className={`row w-100 m-0 p-0 justify-content-center`}>
                            <div className="w text-center mt-3 mb-4 h3" style={{ '--w': '100%' }}>Ajuste de semanas en registros no vinculados</div>
                            <div className="w text-center h4 mt-3" style={{ '--w': '100%' }}>
                                {data?.bloque ?? ''}
                                <span className='ms-3 text-m text-secondary'>{data?.numero_plantas ?? ''} plantas</span>
                            </div>

                            <div className="bw m-1" style={{ '--bw': '150px' }}>
                                <div className="w text-start text-s fw-bold" style={{ '--w': '100%' }}>Semana siembra</div>
                                <input type='text' className='form-control round-xxs shadow-sm bg-light'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.keyCode === 13) {
                                            e.preventDefault();
                                            actualizar();
                                        }
                                    }}
                                    name='semana_siembra' value={data.semana_siembra} onChange={changeData} />
                            </div>
                            <div className="bw m-1" style={{ '--bw': '150px' }}>
                                <div className="w text-start text-s fw-bold" style={{ '--w': '100%' }}>Semana trasplante</div>
                                <input type='text' className='form-control round-xxs shadow-sm bg-light'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.keyCode === 13) {
                                            e.preventDefault();
                                            actualizar();
                                        }
                                    }}
                                    name='semana_trasplante' value={data.semana_trasplante} onChange={changeData} />
                            </div>

                            <div className="bw m-1" style={{ '--bw': '200px' }}>
                                <div className="w text-start text-s fw-bold" style={{ '--w': '100%' }}>Días en vivero</div>
                                <input type='number' className='form-control round-xxs shadow-sm bg-light'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.keyCode === 13) {
                                            e.preventDefault();
                                            actualizar();
                                        }
                                    }}
                                    name='dias_vivero' value={data.dias_vivero} onChange={changeData} />
                            </div>
                            <div className="w m-0 p-0 mt-2 border-bottom" style={{ '--w': '99%' }}></div>

                            <div className="bw m-1" style={{ '--bw': '200px' }}>
                                <div className="w text-start text-s fw-bold" style={{ '--w': '100%' }}>Flor</div>
                                <input type='text' className='form-control round-xxs shadow-sm bg-light'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.keyCode === 13) {
                                            e.preventDefault();
                                            actualizar();
                                        }
                                    }}
                                    name='flor' value={data.flor} onChange={changeData} />
                            </div>

                            <div className="bw m-1" style={{ '--bw': '200px' }}>
                                <div className="w text-start text-s fw-bold" style={{ '--w': '100%' }}>Variedad</div>
                                <input type='text' className='form-control round-xxs shadow-sm bg-light'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.keyCode === 13) {
                                            e.preventDefault();
                                            actualizar();
                                        }
                                    }}
                                    name='variedad' value={data.variedad} onChange={changeData} />
                            </div>

                            <div className="bw m-1" style={{ '--bw': '200px' }}>
                                <div className="w text-start text-s fw-bold" style={{ '--w': '100%' }}>Color</div>
                                <input type='text' className='form-control round-xxs shadow-sm bg-light'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.keyCode === 13) {
                                            e.preventDefault();
                                            actualizar();
                                        }
                                    }}
                                    name='color' value={data.color} onChange={changeData} />
                            </div>
                            <div className="w mt-4 mb-5 text-center" style={{ '--w': '100%' }}>
                                <button className='btn btn-light border border-3 border-warning pt-0 pb-0 bw-150 text-bold shadow btn-lg round-xl'
                                    onClick={actualizar}>
                                    Guardar cambios
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <VainillaDialogV2 data={dialog} />
            </div>
        </>

    )
}

export default EditorSemanasInventarioCampoExterno;